// @flow
/**
 * Renders the content of a slot on a page.
 * NOTE if the slot contains multiple components, it will wrap them in a <div>.
 */
import React, { useContext, Suspense } from 'react';
import EditorContext from 'shared/components/EditorContext';
import BasicSlot from './BasicSlot';

const EditorSlot = React.lazy(() => import(/* webpackChunkName: "internals" */ './EditorSlot'));

const Slot = (props) => {
  const editorContext = useContext(EditorContext);
  const isEditing = editorContext && editorContext.editing;

  return isEditing ? (
    <Suspense fallback={<div />}>
      <EditorSlot {...props} />
    </Suspense>
  ) : <BasicSlot {...props} />;
};

export default Slot;
